"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicPaymentOption = exports.getPublicPaymentOptions = exports.putPaymentOptionAccessibility = exports.deletePaymentOptionPermission = exports.postPaymentOptionPermission = exports.postPaymentOption = exports.putPaymentOption = exports.getPaymentOption = exports.getPaymentOptions = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var paymentOptionsAuthorizedPath = root_1.ecommerceAuthorized + '/paymentoptions/';
var paymentOptionsPublicPath = root_1.ecommercePublic + '/paymentoptions/';

var getPaymentOptions = function getPaymentOptions(authentication, queryParameters) {
  return common_1.get(authentication, paymentOptionsAuthorizedPath, queryParameters);
};

exports.getPaymentOptions = getPaymentOptions;

var getPaymentOption = function getPaymentOption(authentication, id) {
  return common_1.get(authentication, paymentOptionsAuthorizedPath + id);
};

exports.getPaymentOption = getPaymentOption;

var putPaymentOption = function putPaymentOption(authentication, paymentoption) {
  return common_1.put(authentication, paymentOptionsAuthorizedPath + paymentoption.id, paymentoption);
};

exports.putPaymentOption = putPaymentOption;

var postPaymentOption = function postPaymentOption(authentication, paymentoption) {
  return common_1.post(authentication, paymentOptionsAuthorizedPath, paymentoption);
};

exports.postPaymentOption = postPaymentOption;

var postPaymentOptionPermission = function postPaymentOptionPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, paymentOptionsAuthorizedPath, id, permission);
};

exports.postPaymentOptionPermission = postPaymentOptionPermission;

var deletePaymentOptionPermission = function deletePaymentOptionPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, paymentOptionsAuthorizedPath, id, permissionId);
};

exports.deletePaymentOptionPermission = deletePaymentOptionPermission;

var putPaymentOptionAccessibility = function putPaymentOptionAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, paymentOptionsAuthorizedPath, id, accessibility);
};

exports.putPaymentOptionAccessibility = putPaymentOptionAccessibility;

var getPublicPaymentOptions = function getPublicPaymentOptions(authentication, queryParameters) {
  return common_1.get(authentication, paymentOptionsPublicPath, queryParameters);
};

exports.getPublicPaymentOptions = getPublicPaymentOptions;

var getPublicPaymentOption = function getPublicPaymentOption(authentication, id) {
  return common_1.get(authentication, paymentOptionsPublicPath + id);
};

exports.getPublicPaymentOption = getPublicPaymentOption;